import { createConsumer } from "@rails/actioncable";

const currentUserId = document.querySelector("meta[name=\"current-user-id\"]").getAttribute("content");

if (currentUserId) {
  const consumer = createConsumer();
  consumer.subscriptions.create({ channel: "NotificationsChannel", user_id: currentUserId }, {
    received(data) {
      alert(`Job finished: ${data.message}`);
    }
  });
} else {
  console.error("current_user_id is not defined");
}
